export default "__VITE_ASSET__7c5PFyjZ__"